import script from "./StrongAuthentication.vue?vue&type=script&setup=true&lang=ts"
export * from "./StrongAuthentication.vue?vue&type=script&setup=true&lang=ts"

import "./StrongAuthentication.vue?vue&type=style&index=0&id=4eb0e62a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb0e62a"]])

export default __exports__